import React from 'react';
import PropTypes from 'prop-types';

import { Flex, Span } from '@ubisend/pulse-components';
import { TemplatingTextInput } from '@ubisend/pulse-templating';

const transferVoiceCallContent = ({ content, onChange }) => {
  const handleTransferTargetChange = transferTarget => {
    onChange({ transferTarget });
  };

  return (
    <Flex center fat xSpace>
      <Span>to</Span>
      <Flex col fat>
        <TemplatingTextInput
          aria-label="transferTarget"
          placeholder="+4412345678"
          value={content.transferTarget}
          onChange={handleTransferTargetChange}
        />
      </Flex>
    </Flex>
  );
};

transferVoiceCallContent.propTypes = {
  onChange: PropTypes.func.isRequired,
  content: PropTypes.shape({
    transferTarget: PropTypes.string.isRequired
  }).isRequired
};

export default transferVoiceCallContent;
